export default __webpack_public_path__ + "static/media/adTN.e2dd7ece.png";